
import { isSameDay } from 'date-fns'
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'ManufacturingDateCheckMixin',
})
export default class ManufacturingDateCheckMixin extends Vue {
  showManufacturingDateDialog = false

  get manufacturingPlan() {
    return this.$store.getters.manufacturingPlan
  }

  checkManufacturingDate() {
    const completionDate = this.manufacturingPlan?.manufactureCompletionDate
    if (!completionDate) {
      return false
    }

    try {
      const manufactureDate = new Date(completionDate)
      const currentDate = new Date()

      if (!isSameDay(manufactureDate, currentDate)) {
        this.showManufacturingDateDialog = true
        return true
      }
    } catch (error) {
      console.error('Error parsing manufacturing completion date:', error)
    }
  }

  onManufacturingDateDialogConfirm() {
    this.showManufacturingDateDialog = false
    this.$router.replace({ name: 'home' })
  }

  onManufacturingDateDialogCancel() {
    this.showManufacturingDateDialog = false
    this.$router.replace({ name: 'home' })
  }
}
